// extracted by mini-css-extract-plugin
module.exports = {"optionIconElec":"Select_optionIconElec__1QTjq","optionIconGaz":"Select_optionIconGaz__3TT-i","label":"Select_label__3BLAH"};